'use client';

import Image from '@/components/image';
import NextLink from '@/components/next-link';
import { setCookie } from 'cookies-next';
import { useLocale } from 'next-intl';

const BrandCardV2 = ({ info, isMobile }) => {
  const locale = useLocale();
  return (
    <div>
      <NextLink
        href={info?.url ? `/${info?.url}` : '#'}
        onClick={() => {
          setCookie('brand_view_type', 'brands-page');
        }}
        className={`flex flex-col items-center justify-center gap-3 rounded-xl border border-gray-100 bg-slate-50/50 p-2 pb-3 shadow-sm transition-all duration-500 hover:scale-102 sm:max-h-56`}
      >
        <Image
          alt={info?.[`title-${locale}`] || ''}
          className={
            'max-h-[100px] min-h-[100px] w-full rounded-xl object-contain max-sm:max-h-[110px] max-sm:min-h-[110px] max-sm:max-w-[110px] max-sm:min-w-[110px]'
          }
          src={
            isMobile ? info?.[`mobile-img-${locale}`] : info?.[`img-${locale}`]
          }
          width={170}
          height={170}
        />
      </NextLink>
      <p
        className={`mt-2 text-center font-semibold capitalize max-sm:text-sm`}
        title={info?.[`title-${locale}`] || ''}
      >
        {info?.[`title-${locale}`] || ''}
      </p>
    </div>
  );
};

export default BrandCardV2;
